import React, { FC, useState } from "react";
import { IconButton, Menu, MenuItem, ListItemText, ListItemIcon, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { STOCKEDGE_URL, STOCKEDGE_WEBAPP_URL } from "config"

const NineDotDropdown: FC<{ externalResourse?: any }> = () => {
    const theme: any = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };



    const open = Boolean(anchorEl);

    return (
        <Container>
            <IconButton
                id="btnNineDots"
                aria-label="Nine Dots"
                aria-controls={open ? 'btnNineDots' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{
                    "&:hover, &:active": {
                        backgroundColor: "transparent"
                    }
                }}
            >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_5_8)">
                        <path d="M3.75 0H0.75C0.336 0 0 0.336 0 0.75V3.75C0 4.164 0.336 4.5 0.75 4.5H3.75C4.164 4.5 4.5 4.164 4.5 3.75V0.75C4.5 0.336 4.164 0 3.75 0Z" fill="#1D458A" />
                        <path d="M3.75 6.75H0.75C0.336 6.75 0 7.086 0 7.5V10.5C0 10.914 0.336 11.25 0.75 11.25H3.75C4.164 11.25 4.5 10.914 4.5 10.5V7.5C4.5 7.086 4.164 6.75 3.75 6.75Z" fill="#1D458A" />
                        <path d="M3.75 13.5H0.75C0.336 13.5 0 13.836 0 14.25V17.25C0 17.664 0.336 18 0.75 18H3.75C4.164 18 4.5 17.664 4.5 17.25V14.25C4.5 13.836 4.164 13.5 3.75 13.5Z" fill="#1D458A" />
                        <path d="M10.5 0H7.5C7.086 0 6.75 0.336 6.75 0.75V3.75C6.75 4.164 7.086 4.5 7.5 4.5H10.5C10.914 4.5 11.25 4.164 11.25 3.75V0.75C11.25 0.336 10.914 0 10.5 0Z" fill="#1D458A" />
                        <path d="M10.5 6.75H7.5C7.086 6.75 6.75 7.086 6.75 7.5V10.5C6.75 10.914 7.086 11.25 7.5 11.25H10.5C10.914 11.25 11.25 10.914 11.25 10.5V7.5C11.25 7.086 10.914 6.75 10.5 6.75Z" fill="#1D458A" />
                        <path d="M10.5 13.5H7.5C7.086 13.5 6.75 13.836 6.75 14.25V17.25C6.75 17.664 7.086 18 7.5 18H10.5C10.914 18 11.25 17.664 11.25 17.25V14.25C11.25 13.836 10.914 13.5 10.5 13.5Z" fill="#1D458A" />
                        <path d="M17.25 0H14.25C13.836 0 13.5 0.336 13.5 0.75V3.75C13.5 4.164 13.836 4.5 14.25 4.5H17.25C17.664 4.5 18 4.164 18 3.75V0.75C18 0.336 17.664 0 17.25 0Z" fill="#1D458A" />
                        <path d="M17.25 6.75H14.25C13.836 6.75 13.5 7.086 13.5 7.5V10.5C13.5 10.914 13.836 11.25 14.25 11.25H17.25C17.664 11.25 18 10.914 18 10.5V7.5C18 7.086 17.664 6.75 17.25 6.75Z" fill="#1D458A" />
                        <path d="M17.25 13.5H14.25C13.836 13.5 13.5 13.836 13.5 14.25V17.25C13.5 17.664 13.836 18 14.25 18H17.25C17.664 18 18 17.664 18 17.25V14.25C18 13.836 17.664 13.5 17.25 13.5Z" fill="#1D458A" />
                    </g>
                    <defs>
                        <clipPath id="clip0_5_8">
                            <rect width="18" height="18" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </IconButton>
            <Menu
                id="btnNineDots"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        maxWidth: "280px",
                        padding: 0,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}

            >
                <Typography sx={{
                    fontFamily: 'Roboto',
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "12px",
                    lineHeight: "16px",
                    color: isDark ? "#F1F2F3" : "#1D458A",
                    padding: "0 15px",
                    marginBottom: "12px"
                }}>Access StockEdge WebApp & Websites</Typography>
                {/* <MenuItem component="a" target="_blank" href="https://identity.elearnmarkets.in" onClick={handleClose} sx={{ padding: "0.5rem 1rem" }}>
                    <ListItemIcon sx={{ minWidth: "24px !important" }}>
                        <Image src="https://d24uab5gycr2uz.cloudfront.net/uploads/white_theme/images/elm-short-logo.png" alt="Elearnmarkets" />
                    </ListItemIcon>
                    <ListItemText sx={{
                        ".MuiTypography-body1": {
                            fontFamily: 'Roboto',
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: isDark ? "#bdbdbd" : "#12274B"
                        }
                    }}>Elearnmarkets</ListItemText>
                </MenuItem> */}
                <MenuItem component="a" target="_blank" href={STOCKEDGE_WEBAPP_URL} onClick={handleClose} sx={{ padding: "0.5rem 1rem" }}>
                    <ListItemIcon sx={{ minWidth: "24px !important" }}>
                        <Image src="https://duzycfafl38re.cloudfront.net/Media/logo170920201428530111202113533503112021105517.png" alt="StockEdge" />
                    </ListItemIcon>
                    <ListItemText sx={{
                        ".MuiTypography-body1": {
                            fontFamily: 'Roboto',
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: isDark ? "#bdbdbd" : "#12274B"
                        }
                    }}>StockEdge WebApp</ListItemText>
                </MenuItem>
                <MenuItem component="a" target="_blank" href={window.location.origin} onClick={handleClose} sx={{ padding: "0.5rem 1rem" }}>
                    <ListItemIcon sx={{ minWidth: "24px !important" }}>
                        <Image src="https://social.stockedge.com/static/media/9eb3c6b8b88e354b7f49.png" alt="StockEdge Social" />
                    </ListItemIcon>
                    <ListItemText sx={{
                        ".MuiTypography-body1": {
                            fontFamily: 'Roboto',
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: isDark ? "#bdbdbd" : "#12274B"
                        }
                    }}>StockEdge Social</ListItemText>
                </MenuItem>
                <MenuItem component="a" target="_blank" href={STOCKEDGE_URL} onClick={handleClose} sx={{ padding: "0.5rem 1rem" }}>
                    <ListItemIcon sx={{ minWidth: "24px !important" }}>
                        <Image src="https://duzycfafl38re.cloudfront.net/Media/logo170920201428530111202113533503112021105517.png" alt="StockEdge" />
                    </ListItemIcon>
                    <ListItemText sx={{
                        ".MuiTypography-body1": {
                            fontFamily: 'Roboto',
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: isDark ? "#bdbdbd" : "#12274B"
                        }
                    }}>StockEdge Website</ListItemText>
                </MenuItem>
            </Menu>
        </Container>
    )
}

export default NineDotDropdown;

const Image = styled.img`
    width: 30px;
    height: 30px;
    margin-right: 12px;
    vertical-align: middle;
`;

const Container = styled.div`
    .MuiIconButton-root {
        svg {
            fill: #12274b;
        }
        &:hover {
            svg {
                fill: #ee9949;
            }
        }
    }
`;
